import { useTableURLParams } from "src/hooks/useTableURLParams.ts";

type BlacklistsTableParamsType = {
  includeDisabledElements: boolean;
};

export const useBlacklistsTableURLParams = () => {
  return useTableURLParams<BlacklistsTableParamsType>(
    { includeDisabledElements: false },
    { includeDisabledElements: (value) => value === "true" }
  );
};
